import { Routes, Route, Navigate } from 'react-router-dom'
import Connect from './pages/Connect'
import Callback from './pages/Callback'
import './styles/global.css'

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Navigate to="/connect" replace />} />
        <Route path="/connect" element={<Connect />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="*" element={<Navigate to="/connect" replace />} />
      </Routes>
    </div>
  )
}

export default App